import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import featuredInImage from '../../assets/featured_in.webp';
import css from './SectionFeaturedIn.module.css';

const SectionFeaturedIn = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <h2 className={css.heading}>CEO & Founder, James Nightingall, Featured In</h2>
      <div className={css.imageContainer}>
        <img className={css.image} src={featuredInImage} alt="Featured In" />
      </div>
    </div>
  );
};

SectionFeaturedIn.defaultProps = {
  rootClassName: null,
  className: null,
};

SectionFeaturedIn.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionFeaturedIn;
